export const getChaptersForComic = (comicId: number) => {
  const chapterCounts: Record<number, number> = {
    1: 1256, 2: 652, 3: 486, 4: 987, 5: 520, 6: 876, 7: 420, 8: 720,
    9: 560, 10: 340, 11: 880, 12: 420, 13: 580, 14: 530, 15: 960, 16: 680,
  };

  const count = chapterCounts[comicId] || 100;
  const chapters = [];
  for (let i = count; i >= 1; i--) {
    chapters.push({
      id: i,
      title: `第${i}话`,
      comicId,
      date: `202${(i % 6) + 1}-${String((i % 12) + 1).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    });
  }
  return chapters;
};

export const getChapterContent = (comicId: number, chapterId: number) => {
  const chapterContents: Record<number, string[]> = {
    1: [
      '九色神雷从天而降，劈开了苍穹，也劈开了命运的枷锁。',
      '楚枫站在废墟之中，浑身浴血，但眼神却比星辰还要明亮。',
      '"这就是……修罗之力吗？"他低声呢喃，感受着体内涌动的力量。',
      '四周的敌人惊恐地后退，没有人敢靠近这个曾经被视为废物的少年。',
      '从今日起，他不再是楚家的耻辱，而是这片大陆上最强的修罗！',
      '远处，一道苍老的声音传来："小子，你的试炼才刚刚开始……"',
      '楚枫抬起头，嘴角勾起一抹自信的微笑。他知道，自己的传奇，从此刻正式开始。',
      '修罗之路，血与火的洗礼，他早已做好了准备。',
    ],
    2: [
      '萧炎站在悬崖边，手中握着一枚古朴的戒指。戒指微微发热，似乎在回应他的召唤。',
      '"三十年河东，三十年河西，莫欺少年穷！"他的声音在峡谷中回荡。',
      '药老的身影从戒指中缓缓浮现，欣慰地看着眼前的少年。',
      '"小家伙，你已经长大了。"药老微笑道。',
      '萧炎猛然跃起，火焰双翼在背后展开。斗气化翼，这是多少强者梦寐以求的境界！',
      '他俯瞰着脚下的加玛帝国，心中充满了豪情壮志。',
      '这一路上，他失去了很多，但也收获了很多。友情、爱情、师徒之情，这些都是他最宝贵的财富。',
      '炎帝之名，将永远铭刻在这片大陆的史册之上。',
    ],
  };

  const content = chapterContents[comicId];
  if (!content) {
    return [
      '新的篇章即将展开……',
      '故事从这里开始，命运的齿轮缓缓转动。',
      '主角踏上了属于自己的冒险之路，前方等待着他的是未知的挑战。',
      '在这条路上，他将遇到伙伴、敌人，以及改变一生的机遇。',
      '每一个选择都将影响他的未来，每一步都充满了危险与希望。',
      '但无论如何，他都不会放弃。因为这是他选择的道路。',
      '敬请期待下一话的精彩内容！',
    ];
  }

  return [
    `第${chapterId}话`,
    ...content.slice(0, Math.min(content.length, chapterId % 8 + 3)),
    '（本章完）',
  ];
};